import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {RequestModel} from '../typings/typing';

interface DealerTargetSummaryInfo {
  targetProcurement: number;
  ytdProcurement: number;
  actualProcurement: number;
  inWarehouseProcessingProcurement: number;
  openedProcurement: number;
  targetCustomer: number;
  ytdCustomer: number;
  actualCustomer: number;
  dealerCount: number;
  procurementAchievedCount: number;
  customerAchievedCount: number;
  customerStillToGo: number;
  procurementStillToGo: number;
  procurementAchievedRate: number;
  customerAchievedRate: number;
}

@Injectable({
  providedIn: 'root',
})
export class SalesPortalService {
  prefix = '/dealer_portal';

  MONTH_ARRAY = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  QUARTER_ARRAY = ['Q1', 'Q2', 'Q3', 'Q4'];

  dealerTargetSummaryInfo: DealerTargetSummaryInfo = {
    targetProcurement: 0,
    ytdProcurement: 0,
    actualProcurement: 0,
    inWarehouseProcessingProcurement: 0,
    openedProcurement: 0,
    targetCustomer: 0,
    ytdCustomer: 0,
    actualCustomer: 0,
    dealerCount: 0,
    procurementAchievedCount: 0,
    customerAchievedCount: 0,
    customerStillToGo: 0,
    procurementStillToGo: 0,
    procurementAchievedRate: 0,
    customerAchievedRate: 0
  };

  constructor(private http: HttpClient) {
  }

  formatThousands(value: number, fillZero: boolean = false): string {
    if (!isNaN(value)) {
      if (fillZero) {
        const res = value?.toFixed(2)
        return res.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else {
      return '0';
    }
  }

  transposeTableData(data: any[]) {
    const transposedData: any = {};
    let columns: any[] = []
    if (Array.isArray(data) && data.length > 0) {
      columns = Object.keys(data[0]);
    }
    columns.forEach(column => {
      transposedData[column] = data.map((row: { [x: string]: any; }) => row[column]);
    });

    return transposedData;
  }


  dealerTargetList(params: any) {
    return this.http.post<RequestModel>(
      `${this.prefix}/dealer/target/list`,
      params
    );
  }

  turnoverSplitDetail(params: any) {
    return this.http.get<RequestModel>(
      `${this.prefix}/dealer/target/turnover/${params.targetYear}/${params.dealerCode}/${params.dealerOrgCode}/${params.dealerChannelCode}?viewFlag=${params.viewFlag}`
    );
  }

  saveTargetClassification(params: any) {
    return this.http.post<RequestModel>(
      `${this.prefix}/dealer/target/saveTargetClassification`,
      params
    );
  }

  customerTargetSplitDetail(params: any) {
    return this.http.get<RequestModel>(
      `${this.prefix}/dealer/target/customer/${params.targetYear}/${params.dealerCode}/${params.dealerOrgCode}/${params.dealerChannelCode}`,
    );
  }

  saveCustomerClassification(params: any) {
    return this.http.post<RequestModel>(
      `${this.prefix}/dealer/target/saveCustomerClassification`,
      params
    );
  }

  dealerTargetSummary(params: any) {
    this.http
      .get<RequestModel>(`${this.prefix}/dealer/target/summary`, {params})
      .subscribe((result: any) => {
        const {rtnCode, rtnData} = result;
        if (rtnCode === 10000) {
          this.dealerTargetSummaryInfo = rtnData;
        }
      });
  }
}
